import React from 'react';
import { Box } from '@ally/metronome-ui';
import { ZIP_PATTERN } from '@ally/aos-utils';
import { TextInput } from '../../inputs';
export const zipValidator = (value, required = false) => {
    const isValidZip = RegExp(ZIP_PATTERN).test(value);
    if (required && !value) {
        return 'Enter a ZIP Code to continue.';
    }
    if (value && !isValidZip) {
        return 'Enter a valid ZIP Code.';
    }
    return undefined;
};
const Zip = ({ className, label = 'ZIP Code', name, required = false, validate: override, width, }) => {
    const fallback = (value) => zipValidator(value, required); // pass `required` prop to `defaultValidate`
    return (React.createElement(Box, { className: className, width: width },
        React.createElement(TextInput, { labelContent: label, autoComplete: "postal-code", isPrivate: true, inputType: "text", name: name, pattern: "[0-9]*", validate: override || fallback })));
};
export default Zip;
//# sourceMappingURL=Zip.js.map